module.exports = __webpack_public_path__ + "static/img/sticker-hot-sale.e242a3d.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/salepage/banner/sticker/sticker-hot-sale.webp
// module id = kLj5
// module chunks = 134